module.exports = __webpack_public_path__ + "static/Variant.2ae1b04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Variant.png
// module id = ./src/images/Variant.png
// module chunks = 4016850265702045000